export const ActionTypes = {
  FETCH_HUBS_REQUEST: 'FETCH_HUBS_REQUEST',
  FETCH_HUBS_RESPONSE: 'FETCH_HUBS_RESPONSE',
  PROVISION_HUB: 'PROVISION_HUB',
}
